// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
// 引入全局样式
import '../src/css/global.scss';
// 引入网络请求模块
import { post } from './api/http.js';
Vue.prototype.$post = post;
// 引入接口配置文件
import url from './api/service.js';
Vue.prototype.URL = url;

import {
  Cell,
  CellGroup,
  Field,
  Icon,
  Search,
  Toast,
  List,
  Overlay,
  RadioGroup,
  Radio,
  DatetimePicker,
  Picker,
  Dialog, Tag
} from 'vant';
Vue.use(Field).use(Cell).use(CellGroup).use(Icon);
Vue.use(Search).use(Toast).use(List).use(Overlay);
Vue.use(RadioGroup).use(Radio).use(DatetimePicker);
Vue.use(Picker).use(Dialog).use(Tag);
// 绑定提示框
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
/**
 * 注册过滤器
 */
// 时间过滤器，只留年月日

Vue.filter("dateSub", function (str) {
  if (str) {
    return str.substr(0, 10)
  }
  return ""
})



new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js